const { fetchWithRetry } = require('./utils'); // Utility function to parse cookies  

// Function to create a pass  
const createPass = async (passData) => {
    try {
        const response = await fetchWithRetry('/api/passes', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(passData),
        });

        if (!response.ok) {
            throw new Error(`Error creating pass: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error creating pass:', error);
        throw error;
    }
};

// Function to get passes  
const getPasses = async () => {
    try {
        const response = await fetchWithRetry('/api/passes', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`Error fetching passes: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error fetching passes:', error);
        throw error;
    }
};

// Function to update a pass  
const updatePass = async (passId, passData) => {
    try {
        const response = await fetchWithRetry(`/api/passes/${passId}`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(passData),
        });

        if (!response.ok) {
            throw new Error(`Error updating pass: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error updating pass:', error);
        throw error;
    }
};

// Function to delete a pass  
const deletePass = async (passId) => {
    try {
        const response = await fetchWithRetry(`/api/passes/${passId}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`Error deleting pass: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error deleting pass:', error);
        throw error;
    }
};

// Function to get passes by IDs  
const getPassesByIds = async (ids) => {
    try {
        const response = await fetchWithRetry('/api/passes/by-ids', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ ids }),
        });

        if (!response.ok) {
            throw new Error(`Error fetching passes by IDs: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error fetching passes by IDs:', error);
        throw error;
    }
};

// Function to add pass to invoice  
const addPassToInvoice = async (passId, invoiceId, idNumber, name) => {
    try {
        const response = await fetchWithRetry(`/api/passes/${passId}/add-to-invoice/${invoiceId}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ idNumber, name }),
        });

        if (!response.ok) {
            throw new Error(`Error adding pass to invoice: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error adding pass to invoice:', error);
        throw error;
    }
};

module.exports = {
    createPass,
    getPasses,
    updatePass,
    deletePass,
    getPassesByIds,
    addPassToInvoice,
};  